/** Copy for the missing-fields notice on the investor profile (MYN-278, FR-186). */
export const INVESTOR_READINESS_STRINGS = {
  NOTICE_LEAD: 'To be considered for matching, please complete the following fields:',
} as const;
